import LogoMarquee from "./LogoMarquee";
import { CLIENTS } from "../data/content";
import { useLang } from "../i18n";

// Project experience wall — names describe where our people have worked.
export const ClientStrip = ({ index = "" }) => {
  const { t } = useLang();
  const c = t.clients;
  return (
    <LogoMarquee
      items={CLIENTS}
      testId="client-strip"
      plateId="client-plate"
      index={index}
      label={c.label}
      title={c.title}
      lead={c.lead}
      note={c.note}
      meta="country"
    />
  );
};

export default ClientStrip;
